import type { RootState } from '@/store';

export const selectAuthToken = (state: RootState): Nullable<string> => state.auth?.jwtToken;
export const selectUserId = (state: RootState): number => state.auth?.userId || 0;
export const selectUserActiveGroupId = (state: RootState): number =>
  state.auth.tokenVerification?.pvActiveGroupID || 1;
export const isAdministratorSelector = (state: RootState) =>
  state.auth.tokenVerification?.pvAdministrator === 1;
export const tokenVerificationSelector = (state: RootState) => state.auth.tokenVerification;
export const groupAccountSelector = (state: RootState) => {
  const groupId = state.auth?.tokenVerification?.pvActiveGroupID || 0;
  const currentGroups = state.auth?.tokenVerification?.currentGroups || [];
  return currentGroups.find((group) => +group.i === +groupId) || null;
};
export const userActiveGroupSelector = (state: RootState) =>
  state.auth.tokenVerification?.pvActiveGroupID || 0;
